import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

function initEnvironment() {
    return dispatch => {
        return apiCaller
            .call(api.initEnvironment())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'SIMULATIONENR_GIT__SET_GROUPID',
                        groupId: data.groupId
                    });
                    dispatch({
                        type: 'SIMULATIONENR_GIT__SET_ASSIGNEEIDS',
                        assigneeIds: data.assigneeIds
                    });
                    if (data.commercialAgents) {
                        dispatch({
                            type: 'SIMULATIONENR__INIT_COMMERCIALAGENTS',
                            commercialAgents: data.commercialAgents
                        });
                    } else throw 'general.error.commercialAgents_have_not_been_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironmentSimulationenr - ', error);
                throw error;
            });
    };
}

function disconnectEnvironment() {
    return dispatch => {
        dispatch({
            type: 'RESET_STORE'
        });
    };
}
export { initEnvironment, disconnectEnvironment };



// WEBPACK FOOTER //
// ./environments/simulationenr/actions.js